<template>
  <button
    :disabled="disabled || loading"
    :class="[
      type === ButtonType.Primary
        ? 'bg-primary text-white border-primary hover:bg-opacity-90 hover:border-opacity-0'
        : type === ButtonType.WhiteGreen
        ? 'bg-white text-primary border-primary'
        : type === ButtonType.Disabled
        ? 'bg-mediumgray text-white border-mediumgray'
        : type === ButtonType.WhiteGray
        ? 'bg-white border-lightestgray text-mediumgray'
        : type === ButtonType.Gray
        ? 'bg-lightgray text-dark border-lightgray'
        : type === ButtonType.Green
        ? 'text-primary border-transparent'
        : type === ButtonType.GreenLight
        ? 'bg-greenlight text-primary border-primary'
        : '',
      disabled ? 'cursor-not-allowed' : '',
      size === 1 ? 'h-9 px-8 text-sm' : 'h-8 px-4 text-xs',
      hex ? 'justify-start' : 'justify-center',
      isSocial ? 'relative' : ''
    ]"
    class="rounded-lg flex flex-row items-center justify-center space-x-2 group transition-all border-2 truncate relative"
    style="white-space: nowrap"
  >
    <svg v-if="loading" class="animate-spin max-h-5 w-5 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-80" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
    <img v-if="iconleft" :src="iconleft" :class="isSocial ? 'absolute left-4' : ''" class="max-h-5" alt="" />
    <div v-if="hex" :style="`background:${hex}`" class="w-5 h-5 rounded-full bg-primary mr-2 border border-lightestgray"></div>
    <span class="font-semibold relative z-10">{{ text }}</span>
    <img v-if="iconright" :src="iconright" class="max-h-5 group-hover:translate-x-1 transition-all duration-300" alt="" />
  </button>
</template>
<script setup lang="ts">
  import { ButtonType } from '~/types/enums'
  const props = defineProps({
    type: {
      type: Number as () => ButtonType,
      required: false,
      default: 1
    },
    text: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    iconleft: {
      type: String,
      required: false,
      default: null
    },
    iconright: {
      type: String,
      required: false,
      default: null
    },
    size: {
      type: Number,
      required: false,
      default: 1
    },
    hex: {
      type: String,
      required: false,
      default: null
    }
  })

  const isSocial = computed(() => props.iconleft?.includes('socials'))
</script>
